/**
 * Caché en memoria de respuestas GET, con invalidación por mutación.
 *
 * EL PROBLEMA QUE RESUELVE. Cada visita a una pestaña remonta su vista y la
 * vista vuelve a pedirlo todo: los mazos propios -- que no cambian salvo que
 * uno los toque -- costaban un viaje entero al servidor cada vez, con la
 * pokébola en pantalla mientras tanto. En móvil o con el servidor dormido, ese
 * viaje es EL retraso que se siente.
 *
 * CÓMO. La vista pinta primero lo cacheado (si lo hay) y pide igualmente al
 * servidor por detrás: la respuesta fresca sustituye a la vieja y renueva la
 * caché. Nunca se deja de revalidar -- la caché quita la espera, no la verdad.
 *
 * LA INVALIDACIÓN NO ES COSA DE CADA VISTA. `api()` avisa aquí de toda
 * mutación que salió bien (POST/PUT/DELETE), y se tiran las entradas cuyo
 * recurso fue tocado: guardar, importar, copiar o borrar un mazo limpia la
 * lista cacheada sin que ningún componente tenga que acordarse. Si mañana
 * aparece otro sitio que muta mazos, ya queda cubierto.
 *
 * LA CLAVE LLEVA AL USUARIO DENTRO (`/api/decks#u7`): así una sesión nueva no
 * puede leer lo del anterior por construcción, sin depender de limpiar en el
 * momento justo del login/logout. Vive en memoria: muere con la pestaña, como
 * el token de acceso, y por lo mismo.
 */

const entradas = new Map();

/** Clave de un recurso para un usuario concreto. */
export const claveCache = (path, userId) => `${path}#u${userId}`;

export const leerCache = (clave) => entradas.get(clave);

export const guardarCache = (clave, valor) => {
  entradas.set(clave, valor);
};

/**
 * Tira toda entrada cuyo recurso sea prefijo de la ruta mutada: un PUT a
 * /api/decks/12 invalida la lista cacheada bajo /api/decks, de cualquier
 * usuario -- de la sesión solo hay uno vivo, sobrar no cuesta nada.
 */
export function invalidarPorMutacion(path) {
  for (const clave of entradas.keys()) {
    const recurso = clave.slice(0, clave.lastIndexOf('#u'));
    if (path.startsWith(recurso)) entradas.delete(clave);
  }
}
